import React, { useContext } from 'react';
import './Table.css';
import { useNavigate } from 'react-router-dom';
import DashboardContext from "../../context/DashboardContext"

const missions = [
  {
    id: 'M-PB0023',
    location: 'Punjab',
    date: '23 May, 2025',
    status: 'Completed',
    area: 28,
    alert: 'NIL',
  },
  {
    id: 'M-HYD789',
    location: 'Hyderabad',
    date: '02 Jun, 2025',
    status: 'In Progress',
    area: 32,
    alert: 'Minor',
  },
  {
    id: 'M-BGLR12',
    location: 'Bangalore',
    date: '04 Apr, 2025',
    status: 'Pending',
    area: 15,
    alert: 'Monitor',
  },
  {
    id: 'M-TN0071',
    location: 'Chennai',
    date: '18 Jul, 2025',
    status: 'Completed',
    area: 20,
    alert: 'NIL',
  },
  {
    id: 'M-KL1255',
    location: 'Kerala',
    date: '30 Jun, 2025',
    status: 'Completed',
    area: 56,
    alert: 'Monitor',
  },
  {
    id: 'M-MYSR08',
    location: 'Karnataka',
    date: '09 Jan, 2025',
    status: 'In Progress',
    area: 9,
    alert: 'Critical',
  },
];

const getStatusDot = (status) => {
  const colorMap = {
    'Completed': 'green',
    'In Progress': 'orange',
    'Pending': 'red',
  };
  return <span className="status-dot" style={{ backgroundColor: colorMap[status] }} />;
};

const getAlertIcon = (alert) => {
  const iconMap = {
    'NIL': '/assets/icons/check.png',
    'Minor': '/assets/icons/warningy.png',
    'Monitor': '/assets/icons/scan.png',
    'Critical': '/assets/icons/siren.png',
  };
  return iconMap[alert] || '';
};

const Table = () => {
  const navigate = useNavigate();
  const {setControlTabIndex} = useContext(DashboardContext)
  return (
    <div className="table-container">
      <table className="mission-table">
        <thead>
          <tr>
            <th>Mission ID</th>
            <th>Location <span className="filter-icon">🔽</span></th>
            <th>Date <span className="filter-icon">🔽</span></th>
            <th>Status <span className="filter-icon">🔽</span></th>
            <th>Area (Km²) <span className="filter-icon">🔽</span></th>
            <th>Alerts <span className="filter-icon">🔽</span></th>
          </tr>
        </thead>
        <tbody>
          {missions.concat(missions).map((mission, index) => (
            <tr key={index} onClick={()=> setControlTabIndex(1)}>
              <td>{mission.id}</td>
              <td>{mission.location}</td>
              <td>{mission.date}</td>
              <td>
                {getStatusDot(mission.status)}
                <span className="status-text">{mission.status}</span>
              </td>
              <td>{mission.area}</td>
              <td>
                {/* <span className="alert-icon">{getAlertIcon(mission.alert)}</span> */}
                <div style={{position:"relative", paddingLeft:"20px"}}>
                  <img src={getAlertIcon(mission.alert)} style={{position:"absolute", left:"-2px"}} width="16%" alt='icon' />
                  <span className="alert-text">{mission.alert}</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
